import React, { useState } from 'react';
import {
  Container,
  Typography,
  Grid,
  TextField,
  Button,
  Paper,
  Box,
  Alert,
  MenuItem,
} from '@mui/material';
import { motion } from 'framer-motion';

const inquiryTypes = [
  'New Connection',
  'Service Issue',
  'Billing Question',
  'Package Upgrade',
  'Coverage Inquiry',
  'Other',
];

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    inquiryType: '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 1000));
    setSubmitted(true);
  };

  return (
    <Container sx={{ py: 8 }}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Typography variant="h3" component="h1" gutterBottom align="center">
          Contact Us
        </Typography>
        <Typography variant="h6" gutterBottom align="center" color="text.secondary" sx={{ mb: 6 }}>
          Get in touch with our team for support or inquiries
        </Typography>

        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Paper sx={{ p: 4 }}>
              {!submitted ? (
                <form onSubmit={handleSubmit}>
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <TextField
                        required
                        fullWidth
                        label="Full Name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        required
                        fullWidth
                        label="Email"
                        name="email"
                        type="email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        required
                        fullWidth
                        label="Phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        required
                        fullWidth
                        select
                        label="Inquiry Type"
                        name="inquiryType"
                        value={formData.inquiryType}
                        onChange={handleChange}
                      >
                        {inquiryTypes.map((type) => (
                          <MenuItem key={type} value={type}>
                            {type}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        required
                        fullWidth
                        multiline
                        rows={4}
                        label="Message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Button
                        type="submit"
                        variant="contained"
                        size="large"
                        fullWidth
                      >
                        Send Message
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              ) : (
                <Alert severity="success">
                  Thank you for contacting us! We'll get back to you within 24 hours.
                </Alert>
              )}
            </Paper>
          </Grid>

          <Grid item xs={12} md={6}>
            <Paper sx={{ p: 4, height: '100%' }}>
              <Typography variant="h5" gutterBottom>
                Our Contact Information
              </Typography>
              <Box sx={{ my: 3 }}>
                <Typography variant="body1" gutterBottom>
                  <strong>Customer Support:</strong>
                </Typography>
                <Typography variant="body1" gutterBottom>
                  Phone: +254 716 504 441
                </Typography>
                <Typography variant="body1" gutterBottom>
                  Email: support@devolvedtelco.co.ke
                </Typography>
              </Box>
              <Box sx={{ my: 3 }}>
                <Typography variant="body1" gutterBottom>
                  <strong>Business Hours:</strong>
                </Typography>
                <Typography variant="body1" gutterBottom>
                  Monday - Friday: 8:00 AM - 8:00 PM
                </Typography>
                <Typography variant="body1" gutterBottom>
                  Saturday: 9:00 AM - 5:00 PM
                </Typography>
                <Typography variant="body1" gutterBottom>
                  Sunday: 10:00 AM - 4:00 PM
                </Typography>
              </Box>
              <Box sx={{ my: 3 }}>
                <Typography variant="body1" gutterBottom>
                  <strong>Head Office:</strong>
                </Typography>
                <Typography variant="body1" gutterBottom>
                  Embu Town,
                </Typography>
                <Typography variant="body1" gutterBottom>
                  Embu County, Kenya
                </Typography>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </motion.div>
    </Container>
  );
};

export default Contact;
